module.exports = __webpack_public_path__ + "img/check-plain.d4fd04ac.svg";